module.exports = __webpack_public_path__ + "img/ring_g_c_null_null@3x.b71cfe56.png";